import { isStandalone as isStandaloneDeal } from 'bundles/apex/deals/helpers';

export const isSale = (voucher) => {
  if (voucher.deal) {
    return voucher.deal.dealType === 'sale';
  } else {
    return voucher.listing.type === 'SaleListing';
  }
};

export const isLease = (voucher, { strict } = {}) => {
  if (strict) {
    if (voucher.deal) {
      return voucher.deal.dealType === 'lease';
    } else {
      return voucher.listing.type === 'LeaseSpaceListing';
    }
  } else {
    if (voucher.deal) {
      return voucher.deal.dealType === 'lease' || voucher.deal.dealType === 'tenant_rep';
    } else {
      return voucher.leaseStructure && !voucher.leaseStructure._destroy;
    }
  }
};

export function isLot(voucher) {
  if (voucher.deal) {
    return false;
  } else {
    return voucher.listing.type === 'LotListing';
  }
}

export function isCondo(voucher) {
  if (voucher.deal) {
    return false;
  } else {
    return voucher.listing.type === 'CondoListing';
  }
}

export const isAssignment = (voucher) => {
  if (voucher.deal) {
    return voucher.deal.dealType === 'buyer_rep' || voucher.deal.dealType === 'tenant_rep';
  } else {
    return voucher.listing.type === 'TenantRepListing';
  }
};

export function isTenantRep(voucher) {
  if (voucher.deal) {
    return voucher.deal.dealType === 'tenant_rep';
  } else {
    return voucher.listing.type === 'TenantRepListing' && voucher.listing.leaseClosed;
  }
}

export function isBuyerRep(voucher) {
  if (voucher.deal) {
    return voucher.deal.dealType === 'buyer_rep';
  } else {
    return voucher.listing.type === 'TenantRepListing' && voucher.listing.saleClosed;
  }
}

export function isStandalone(voucher) {
  if (voucher.deal) {
    return isStandaloneDeal(voucher.deal);
  } else {
    return voucher.listing.isStandaloneListing;
  }
}

export const isPropertyListing = (voucher) => {
  if (voucher.deal) {
    return voucher.deal.dealType === 'sale' || voucher.deal.dealType === 'lease';
  } else {
    return isSale(voucher) || isLease(voucher, { strict: true });
  }
};

export const isUnderContract = (voucher) => {
  if (voucher.deal) {
    // TODO: ?
    return voucher.deal.stage === 'transacting';
  } else {
    return voucher.listing.listingStatus === 'under_contract';
  }
};

export const isClosed = (voucher) => {
  if (voucher.deal) {
    return voucher.deal.stage === 'closed';
  } else {
    return voucher.listing.listingStatus === 'closed';
  }
};

export const isOnMarket = (voucher) => {
  if (voucher.deal) {
    // TODO: ?
    return voucher.deal.stage === 'evaluating';
  } else {
    return voucher.listing.listingStatus === 'on_market';
  }
};

export function canCopyToComp(voucher) {
  return (
    isSale(voucher) ||
    isLease(voucher, { strict: true }) ||
    (isAssignment(voucher) && (isUnderContract(voucher) || isClosed(voucher)))
  );
}

export const isLeaseComponentVisible = (voucher) => {
  return isLease(voucher, { strict: true }) || (isLease(voucher) && (isUnderContract(voucher) || isClosed(voucher)));
};
